export default "__VITE_ASSET__DWrd9PTu__"